import React, { FC, useEffect, useState } from 'react';
import Styles from './LineTableV3Refined.module.scss';
import { LineTableBasicPropConfig } from '../../services/LineTableBasicPropConfig';
import { fetchLinetableContent, getStaticContent } from '../../services/LineTableService';
import { SBENDPOINT } from '../../services/api-constants';
import { Carousel } from 'react-bootstrap';
import ProductContainerV3 from './ProductContainerV3';
import { ProductTableSchema } from './lineTable.types';
import Cookies from 'js-cookie';
import { trackNewDatalayerEvent } from '../../utils/AnalyticsUtils';
import { GAEVENT, TABCLICK } from '../../Analytics/AnalyticsConstants';
import Row from '../ResponsiveRow/row';

const ProductTableV3: FC<ProductTableSchema> = ({
  content,
  metadata,
  setGenericErrorModalDetails,
  loginSuccess,
  lineCheckCallBack,
  tabCheckCallBack,
  changeAddressClicked,
  ratePlansToRemove,
  isProdEnv
}): any => {
  const [sbStaticConstants, setSbStaticConstants] = useState<any>();
  const [lineTableContent, setLineTableContent] = useState<any>();
  const [index, setIndex] = useState(0);
  let bundle = typeof window !== 'undefined' && localStorage.getItem('lineCheckResponse');
  let eligibleBundle = bundle && JSON?.parse(bundle);
  let address: any = typeof window !== 'undefined' && Cookies.get('chAddressJson');

  //setting endpoints
  const sbEndPoint = LineTableBasicPropConfig?.getInstance()?.getSBUrl();
  const slugUrl = SBENDPOINT['SLUG_URL'];
  const sbUrl = sbEndPoint + slugUrl;
  const datasourceEndpoint = sbEndPoint + SBENDPOINT['CONSTANTS_KEYS'];
  const sbParams = {
    find_by: 'uuid',
    language: metadata?.lang,
    type: 'B2C',
    value: metadata?.storyId
  };

  /**
   * useffect for singlestory and datasource call
   */
  useEffect(() => {
    //singleStory call
    fetchLinetableContent(sbUrl, sbParams).then((resp: any) => setLineTableContent(resp));
    //datasource call
    getStaticContent(metadata?.lang, datasourceEndpoint)
      .then((res: any) => setSbStaticConstants(res))
      .catch((err: any) =>
        // eslint-disable-next-line no-console
        console.log(err)
      );
  }, []);

  /**
   * for getting the taboption from the url
   */
  useEffect(() => {
    const params = new URLSearchParams(window?.location?.search);
    const option = params?.get('tabOption');
    if (lineTableContent && option !== null) {
      (lineTableContent?.productContainer || []).map((product: any, i: number) => {
        if (product?.tabId === option) {
          setIndex(i);
        }
      });
    }
    const selectedTab=lineTableContent?.productContainer?.[index]?.tabId;
    tabCheckCallBack?.(selectedTab);
  }, [lineTableContent]);

  /**
   * resetting the values when there is a change in linecheck
   */
  useEffect(() => {
    bundle = typeof window !== 'undefined' && localStorage.getItem('lineCheckResponse');
    eligibleBundle = bundle && JSON?.parse(bundle);
    address = typeof window !== 'undefined' && Cookies.get('chAddressJson');
  }, [changeAddressClicked]);

  return (
    <div id='reusable-linetable'>
      {lineTableContent?.productContainer && (
        <>
          <Row>
            <div className={`row  justify-content-center ${Styles.tabblock}`}>
              {lineTableContent?.productContainer?.length > 1 && (
                <div className={` ${Styles.tabcontainer}`}>
                  {(lineTableContent?.productContainer || []).map((product: any, i: number) => {
                    return (
                      <div
                        className={` ${Styles.tabs} ${
                          index === i ? Styles.tabcontentactive : Styles.tabcontentinactive
                        }`}
                        key={product?.tabCaption}
                      >
                        <label className={` ${Styles.tabcontent} `}>
                          <input
                            type='radio'
                            checked={index === i}
                            onChange={() => {
                              setIndex(i);
                              tabCheckCallBack?.(product?.tabId);
                              trackNewDatalayerEvent(GAEVENT, TABCLICK, {
                                click_text: product?.tabCaption
                              });
                            }}
                          />
                          {product?.tabCaption}
                        </label>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </Row>
          <Row resuablelineTable={true}>
            <div className={`${'position-relative'} `}>
              <Carousel
                activeIndex={index}
                indicators={false}
                controls={false}
                interval={null}
                id='pt-carousel'
                slide={false}
              >
                {lineTableContent?.productContainer?.length > 0 &&
                  (lineTableContent?.productContainer || []).map((product: any, i: number) => {
                    return (
                      <Carousel.Item key={i}>
                        <ProductContainerV3
                          content={{
                            ...product,
                            pageType: product.pageType,
                            dynamicProductOffer: true,
                            tabIndex: i,
                            activeIndex: index,
                            lineTableContent: lineTableContent
                          }}
                          metadata={metadata}
                          activeIndex={index}
                          lineCheckCallBack={lineCheckCallBack}
                          tabCheckCallBack={tabCheckCallBack}
                          sbStaticConstants={sbStaticConstants}
                          address={address}
                          eligibleBundle={eligibleBundle}
                          setGenericErrorModalDetails={setGenericErrorModalDetails}
                          loginSuccess={loginSuccess}
                          ratePlansToRemove={ratePlansToRemove}
                          isProdEnv={isProdEnv}
                        />
                      </Carousel.Item>
                    );
                  })}
              </Carousel>
            </div>
          </Row>
        </>
      )}
    </div>
  );
};
export default ProductTableV3;
